"use client";

import Link from "next/link";
import Image from "next/image";

export default function NotFound() {
  return (
    <div
      className="theme-dark min-h-screen flex items-center justify-center p-6"
      style={{ background: "var(--bg-root)" }}
    >
      <div className="text-center max-w-lg animate-fade-in">
        {/* Floating monkey illustration */}
        <div
          className="relative mx-auto mb-8"
          style={{
            width: 280,
            height: 280,
            animation: "float 4s ease-in-out infinite",
          }}
        >
          <Image
            src="/monkey-404.webp"
            alt="Lost monkey astronaut"
            width={280}
            height={280}
            priority
            className="drop-shadow-2xl"
          />
        </div>

        {/* Glitch title */}
        <h1
          className="text-[80px] font-black tracking-tighter leading-none mb-2"
          style={{
            background: "linear-gradient(135deg, var(--brand-teal), var(--brand-teal-light))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "none",
          }}
        >
          404
        </h1>

        <h2
          className="text-[22px] font-bold mb-3 tracking-tight"
          style={{ color: "var(--text-primary)" }}
        >
          Houston, we have a problem
        </h2>

        <p
          className="text-[14px] mb-8 leading-relaxed max-w-sm mx-auto"
          style={{ color: "var(--text-muted)" }}
        >
          Looks like our monkey astronaut took a wrong turn.
          <br />
          This page doesn&apos;t exist or was moved to another galaxy.
        </p>

        {/* Terminal-style hint */}
        <div
          className="inline-block rounded-lg px-5 py-3 mb-8 text-left"
          style={{
            background: "rgba(0,0,0,0.3)",
            border: "1px solid var(--border)",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          <span style={{ color: "var(--text-muted)" }}>$ </span>
          <span style={{ color: "var(--danger)" }}>Error</span>
          <span style={{ color: "var(--text-muted)" }}>: </span>
          <span style={{ color: "var(--text-secondary)" }}>
            route <span style={{ color: "var(--brand-teal)" }}>&quot;/???&quot;</span> not found
          </span>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/"
            className="btn btn-primary inline-flex items-center justify-center gap-2"
            style={{ padding: "12px 28px" }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Go home
          </Link>

          <button
            onClick={() => history.back()}
            className="inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-[13px] transition-all duration-200 cursor-pointer"
            style={{
              padding: "12px 28px",
              background: "rgba(163,202,211,0.06)",
              border: "1px solid var(--border)",
              color: "var(--text-secondary)",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Go back
          </button>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-12px) rotate(2deg); }
          75% { transform: translateY(6px) rotate(-1deg); }
        }
      `}</style>
    </div>
  );
}
